var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6129_2153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6129_2153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.08979 17.0834C5.67424 17.0834 5.31924 16.9362 5.02479 16.6419C4.73049 16.3475 4.58333 15.9925 4.58333 15.5769V5.00002H3.75V3.75002H7.5V3.01294H12.5V3.75002H16.25V5.00002H15.4167V15.5769C15.4167 15.9979 15.2708 16.3542 14.9792 16.6459C14.6875 16.9375 14.3312 17.0834 13.9102 17.0834H6.08979ZM14.1667 5.00002H5.83333V15.5769C5.83333 15.6518 5.85736 15.7132 5.90542 15.7613C5.95347 15.8093 6.01493 15.8334 6.08979 15.8334H13.9102C13.9744 15.8334 14.0331 15.8066 14.0865 15.7531C14.1399 15.6998 14.1667 15.6411 14.1667 15.5769V5.00002ZM7.83667 14.1667H9.08646V6.66669H7.83667V14.1667ZM10.9135 14.1667H12.1633V6.66669H10.9135V14.1667Z",
    fill: "#409958"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGreen);
export default __webpack_public_path__ + "static/media/delete-green.f01d3e893fdba3b305d81b17407e9697.svg";
export { ForwardRef as ReactComponent };